module.exports = __webpack_public_path__ + "plasma-proteins.b75a490b93de21cb43c070bec1c28b65.png";